import gql from 'graphql-tag'

export default gql`{
  permissions{
    permission_id
    name
  }
}`